import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!loading && user) navigate("/app"); }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white flex flex-col justify-center px-6">
      <div className="w-full max-w-sm mx-auto">
        <Link to="/" className="flex items-center gap-2 mb-10">
          <Logo size="lg" />
        </Link>
        <h1 className="font-display text-3xl font-black mb-2">Bon retour 👋</h1>
        <p className="text-white/50 text-sm mb-8">Connecte-toi pour retrouver ton programme.</p>

        <button data-testid="auth-google-button" onClick={handleGoogleLogin}
          className="w-full flex items-center justify-center gap-3 rounded-xl bg-white text-[#0A0F0D] font-semibold py-3.5 mb-5 active:scale-95 transition-transform hover:bg-lime-50">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5" />
          Continuer avec Google
        </button>
        <div className="flex items-center gap-3 my-5">
          <div className="h-px flex-1 bg-white/10" /><span className="text-xs text-white/30">ou</span><div className="h-px flex-1 bg-white/10" />
        </div>

        <form onSubmit={submit} className="space-y-3">
          <input data-testid="auth-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-lime-400/50" />
          <input data-testid="auth-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-lime-400/50" />
          <button data-testid="auth-submit-button" type="submit" disabled={busy}
            className="w-full bg-lime-400 text-black font-extrabold py-3.5 rounded-xl hover:bg-[#b0e600] active:scale-95 transition-all disabled:opacity-60">
            {busy ? "Connexion…" : "Se connecter"}
          </button>
        </form>
        <Link to="/forgot-password" data-testid="forgot-password-link" className="block text-center text-sm text-white/50 hover:text-lime-400 mt-4">
          Mot de passe oublié ?
        </Link>
        <p className="text-sm text-white/50 mt-4 text-center">
          Pas encore de compte ? <Link to="/questionnaire" className="text-lime-400 font-semibold">Commencer</Link>
        </p>
      </div>
    </div>
  );
}
